import React from 'react';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Textarea } from '../../../components/ui/textarea';
import { MessageSquare } from 'lucide-react';
import { formatDate } from '../../../lib/utils';

const NotesTab = ({ candidate, newNote, setNewNote, addNote }) => (
  <div className="space-y-4 md:space-y-6">
    <Card className="p-4 md:p-6 border-tp-border">
      <h3 className="text-base md:text-lg font-display font-semibold text-tp-text mb-3 md:mb-4">Ajouter une note</h3>
      <div className="space-y-3">
        <Textarea
          placeholder="Ajouter une note sur ce candidat..."
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          rows={3}
          data-testid="note-textarea"
        />
        <Button onClick={addNote} className="bg-tp-primary hover:bg-tp-primary-light" data-testid="add-note-button">
          <MessageSquare className="h-4 w-4 mr-2" />
          Ajouter la note
        </Button>
      </div>
    </Card>

    <Card className="p-4 md:p-6 border-tp-border">
      <h3 className="text-base md:text-lg font-display font-semibold text-tp-text mb-3 md:mb-4">Historique des notes</h3>
      {candidate.admin_notes?.length > 0 ? (
        <div className="space-y-4">
          {candidate.admin_notes.map((note, index) => (
            <div key={`note-${note.created_at}-${index}`} className="border-l-2 border-tp-accent pl-4 py-2">
              <p className="text-sm text-tp-text">{note.note}</p>
              <p className="text-xs text-tp-text-light mt-2">
                {note.admin_name} • {formatDate(note.created_at)}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-tp-text-light">Aucune note pour l'instant</p>
      )}
    </Card>
  </div>
);

export default NotesTab;
